import type { Client } from '../../../api/client.js';

/**
 * Vidéos du dossier (PARITE-5, démo facturation-ged/VideosDossier, #54) : routes du contrat `videos.*` seulement. Une vidéo est
 * une adresse YouTube (aucun fichier). Le partage au portail envoie la liste des destinataires AFFICHÉE dans l'alerte.
 */
export interface VideoDossier {
  id: string;
  dossierId: string;
  title: string;
  url: string;
  youtubeId: string;
  embedUrl: string;
  createdAt: string;
  createdByDisplayName: string;
  sharedWithFamilyAt: string | null;
  sharedByDisplayName: string | null;
  sharedWith: string[];
  rowVersion: number;
}

export interface Destinataire {
  userId: string;
  displayName: string;
  role: 'heritier' | 'mandant';
}

export interface VideosDuDossier {
  videos: VideoDossier[];
  recipients: Destinataire[];
}

export interface SourceVideos {
  lister(): Promise<VideosDuDossier>;
  rattacher(title: string, url: string): Promise<VideoDossier>;
  retirer(id: string): Promise<void>;
  partager(id: string, destinataires: Destinataire[], affiches: string[]): Promise<VideoDossier>;
  retirerPartage(id: string): Promise<VideoDossier>;
}

export const PERMISSION_ECRIRE_VIDEOS = 'video:write:dossier';
export const PERMISSION_PARTAGER_VIDEOS = 'video:share:dossier';

export function creerSourceVideos(client: Client, dossierId: string): SourceVideos {
  return {
    lister: () => client.appeler<VideosDuDossier>('videos.lister', { parametres: { dossierId } }),
    rattacher: (title, url) => client.appeler<VideoDossier>('videos.rattacher', { parametres: { dossierId }, corps: { title, url } }),
    retirer: async (id) => {
      await client.appeler('videos.retirer', { parametres: { videoId: id } });
    },
    partager: (id, destinataires, affiches) =>
      client.appeler<VideoDossier>('videos.partager', {
        parametres: { videoId: id },
        corps: {
          recipients: destinataires.map((d) => ({ userId: d.userId, displayName: d.displayName })),
          acknowledgedRecipients: affiches,
        },
      }),
    retirerPartage: (id) => client.appeler<VideoDossier>('videos.partage.retirer', { parametres: { videoId: id } }),
  };
}
